import { useMemo, useState } from 'react';
import { useTheme } from './useTheme';
import { normaliserNiveau } from '../../generators/ouverture';

/**
 * Référentiel des niveaux inférieurs à celui de la classe (F1, R13) : pour une
 * 4e, la 5e puis la 6e, du plus proche au plus lointain. Rien n'est chargé
 * avant la première recherche (`actif`), ni pour une 6e, ni pour un niveau
 * inconnu ; une fois chargé, le référentiel reste en mémoire pour les
 * recherches suivantes. Trois appels fixes : un hook ne s'appelle pas un
 * nombre variable de fois.
 * @returns {{ niveaux: Array<{ niveau: string, themes: Array }>, chargement: boolean }}
 */
export const useThemesPrecedents = (niveau, actif) => {
  const [arme, setArme] = useState(false);
  if (actif && !arme) setArme(true);
  const normalise = normaliserNiveau(niveau);
  const n = normalise ? Number(normalise[0]) : null;
  const voulu = (k) => arme && n !== null && k > n;
  const t4 = useTheme(4, voulu(4) ? undefined : 'not-enabled');
  const t5 = useTheme(5, voulu(5) ? undefined : 'not-enabled');
  const t6 = useTheme(6, voulu(6) ? undefined : 'not-enabled');
  return useMemo(() => {
    const parNiveau = [[4, t4], [5, t5], [6, t6]].filter(([k]) => n !== null && k > n);
    return {
      niveaux: parNiveau.map(([k, { data }]) => ({ niveau: String(k), themes: Array.isArray(data) ? data : [] })),
      chargement: parNiveau.some(([, { isLoading }]) => isLoading),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- seuls les champs lus comptent
  }, [n, t4.data, t4.isLoading, t5.data, t5.isLoading, t6.data, t6.isLoading]);
};
